// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2EE0i","fullScreen":"style_fullScreen__2b9se","hidden":"style_hidden__1J7aP"};